import axios, { handleResponse } from "utils/axios";

const getAllPayments = async (query) => {
  return axios({
    method: "get",
    url: "/payments",
    params: query,
  }).then(handleResponse);
};

const getAllCharges = async (query) => {
  return axios({
    method: "get",
    url: "/charges",
    params: query,
  }).then(handleResponse);
};

const getPaymentsById = async (id) => {
  return axios({
    url: `/payments/${id}`,
  }).then(handleResponse);
};

const resolvePayment = async (id, data) => {
  return axios({
    method: "post",
    url: `/charges/code/${id}/resolve`,
    data,
  }).then(handleResponse);
};

const refundPayment = async (id) => {
  return axios({
    method: "post",
    url: `/charges/code/${id}/refund`,
  }).then(handleResponse);
};

/*
* data: {
*   "startTime": 1,
    "endTime": 1645528276000,
    "transactionType": "PRODUCT_CHECKOUT"
* }
* */
const generateReport = async (data) => {
  return axios({
    method: "post",
    url: `/payments/report`,
    data,
  }).then(handleResponse);
};

export { getAllPayments, getPaymentsById, resolvePayment, refundPayment, generateReport, getAllCharges };
